import store from '../../store/configureStore';
import { getActiveWorkspaceId, getViewAsUser } from '../../utils/bzmUserConfigUtil';
import { appendViewAs } from '../../utils/urlUtils';

/**
 * Axios request interceptor to modify the request URL.
 *
 * This interceptor performs the following actions:
 * 1. If the `blazeUserConfig` is loaded, it injects the `workspaceId` and `accountId` into the URL.
 * 2. If the `view_as` user is activated, it appends the `view_as` parameter to the URL.
 *
 * @param {Object} request - The Axios request object.
 * @returns {Object} - The modified Axios request object.
 */
export const requestInterceptor = request => {
  let url = request.url;
  // If blazeUser config is available, let's try to inject workspace id to the call
  if ((store.getState() as any).blazeUserConfig.isLoading === false) {
    const workSpaceId = getActiveWorkspaceId();
    // replace all occurrences of {workspaceId} param (case insensitively) with the actual value
    url = url.replace(/{workspaceId}/gi, workSpaceId);

    // replace all occurrences of {accountId} param (case insensitively) with the actual value
    const accountId = (store.getState() as any).blazeUserConfig.blazeUserConfig.user.activeAccountId;
    url = url.replace(/{accountId}/gi, accountId);

    request.url = url;
  }
  // If view_as user is activated
  const viewAs = getViewAsUser();
  if (viewAs) {
    request.url = appendViewAs(url, viewAs);
  }
  return request;
};
